@if (hasWNL) {
<div class="wnl-checkbox">
  <p-checkbox [value]="wnlLabel" [(ngModel)]="wnl" (ngModelChange)="toggleWNL()" [binary]="true" />
  <label class="label-right-of-box" for="pchckbox">WNL</label>
</div>
}
@for (option of options; track $index) {
<div class="option-checkbox">
  <p-checkbox id="pchckbox" [value]="option.label" [formControl]="control" />
  <label class="label-right-of-box" for="pchckbox">{{option.label}}</label>
</div>
}